// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "e20e28d97b6c2f94b576" + "/js/" + chunkId + ".js";
};